<template>
  <b-row>
    <b-col cols="12">
      <b-card title="Division List">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
            >
              <label>Show</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="mr-1 per-page-selector d-inline-block ml-50"
              />
              <b-button v-b-modal.assign-param variant="primary"
                >Add Division</b-button
              >
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
              class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
            >
              <label class="mr-1">
                Search
              </label>
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  class="mr-1 d-inline-block"
                  placeholder="Search..."
                  v-model="searchWord"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- Larger screen than mobile -->
        <div class="d-none d-md-flex">
          <b-table
            class="border"
            no-local-sorting
            @sort-changed="sortingChanged"
            responsive
            striped
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items="division"
            :fields="divisionFields"
          >
            <template #cell(action)="divisionItem">
              <div class="d-flex">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="secondary"
                  class="mr-1 btn-icon"
                  @click="editModal(divisionItem.item.id,divisionItem.item.division,divisionItem.item.description,divisionItem.item.cfu)"
                >
                  <feather-icon icon="Edit3Icon" />
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="mr-1 btn-icon"
                  @click="showMsgBoxDelete(divisionItem.item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
        <!-- Mobile screen -->
        <div class="d-flex d-md-none flex-column">
          <!-- Loading -->
          <div v-if="isBusy" class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <!-- Data -->
          <b-row
            v-if="!isBusy"
            v-for="(item, index) in division"
            :key="item.id"
            class="mb-3 list-item"
          >
            <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
              <strong class="flex-grow-1 truncate">{{ item.division }}</strong>
              <div>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="secondary"
                  class="mr-1 btn-icon"
                  @click="editModal(item.id,item.division,item.description,item.cfu)"
                >
                  <feather-icon icon="Edit3Icon" />
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="mr-1 btn-icon"
                  @click="showMsgBoxDelete(item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </div>
            </b-col>
            <b-col cols="12" class="d-flex flex-wrap">
              <div style="font-size: 0.75rem;">
                <p><strong>DESCRIPTION:</strong> {{ item.description }}</p>
                <p><strong>CFU:</strong> {{ item.cfu ? item.cfu.name : '-' }}</p>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Showing {{ pagination.from }} to {{ pagination.to }} of
                {{ pagination.total }} entries
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="pagination.total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="changePage"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-modal
        title="Add New Division"
        hide-footer
        id="assign-param"
        centered
        hide-header-close
      >
        <b-form @submit.prevent="addDivision">
          <b-form-group label-for="name">
            <template slot="label">
              <span>Name <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="title" required v-model="new_division" />
          </b-form-group>
          <b-form-group label-for="description">
            <template slot="label">
              <span>Description <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="title" required v-model="new_desc" />
          </b-form-group>
          <b-form-group label-for="cfu">
            <template slot="label">
              <span>CFU <strong class="text-danger">*</strong></span>
            </template>
            <v-select
              v-model="cfuSelected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              key="id"
              label="name"
              :options="cfuOption"
            />
          </b-form-group>
          <b-form-group class="mt-1 d-flex justify-content-end">
            <b-button
              type="button"
              variant="light"
              class="mr-1"
              @click="$bvModal.hide('assign-param')"
              :disabled="form.isLoading"
            >
              Cancel
            </b-button>
            <b-button type="submit" variant="primary" :disabled="form.isLoading">
              Save
            </b-button>
          </b-form-group>
        </b-form>
      </b-modal>
      <b-modal
        title="Edit Division"
        hide-footer
        id="edit-param"
        centered
        hide-header-close
      >
        <b-form @submit.prevent="editParam">
          <b-form-group label-for="name">
            <template slot="label">
              <span>Name <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="title" required v-model="edit_param_name" />
          </b-form-group>
          <b-form-group label-for="description">
            <template slot="label">
              <span>Description <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="title" required v-model="edit_param_desc" />
          </b-form-group>
          <b-form-group label-for="cfu">
            <template slot="label">
              <span>CFU <strong class="text-danger">*</strong></span>
            </template>
            <v-select
              v-model="cfuSelectedEdit"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              key="id"
              label="name"
              :options="cfuOption"
            />
          </b-form-group>
          <b-form-group class="d-flex justify-content-end">
            <b-button
              type="button"
              variant="light"
              class="mr-1"
              @click="$bvModal.hide('edit-param')"
              :disabled="form.isLoading"
            >
              Cancel
            </b-button>
            <b-button type="submit" variant="primary" :disabled="form.isLoading">
              Save
            </b-button>
          </b-form-group>
        </b-form>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BSpinner,
  BCard,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSpinner,
    BCard,
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BPagination,
    BModal,
    VSelect,
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      form: { isLoading: false },
      new_division: null,
      new_desc: null,
      edit_param_id: '',
      edit_param_name: '',
      edit_param_desc: '',
      cfuSelected: null,
      cfuSelectedEdit: null,
      cfuOption: [],
      sortBy: 'id',
      sortDesc: false,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      division: [],
      divisionFields: [
        {
          key: 'division',
          label: 'Name'
        },
        {
          key: 'description',
          label: 'Description'
        },
        {
          key: 'cfu',
          formatter: (val, key, item) => {
            return val ? val.name : ''
          },
          label: 'CFU'
        },
        'action',
      ],
      selectedPCC: '',
      searchWord: '',
    }
  },

  watch: {
    perPage() {
      this.fetchDivision()
    },
    currentPage() {
      this.fetchDivision()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
  },

  mounted() {
    this.fetchDivision()
    this.fetchCfu()
  },

  methods: {
    fetchDivision() {
      this.isBusy = true

      this.$http
        .get('/division-config', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim(),
            sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.division = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    fetchCfu() {
      this.$http
        .get('/cfu', {
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.cfuOption = data.data.records
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    searchByTitle: debounce(function() {
      this.fetchDivision()
    }, 200),

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchDivision()
    },

    deleteDivision(id) {
      return this.$http.delete(`division-config/delete/${id}`)
    },

    addDivision() {
      this.form.isLoading = true

      this.$http
        .post('/division-config/store', {
          name: this.new_division,
          desc: this.new_desc,
          cfu: this.cfuSelected,
        })
        .then(() => {
          this.$notif(
            'Success',
            'Param successfully assigned.',
            'success'
          )
          this.$bvModal.hide('assign-param')
          this.new_division = null
          this.new_desc = null
          this.edit_param_id = ''
          this.edit_param_name = ''
          this.cfuSelected = null
          this.fetchDivision()
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => (this.form.isLoading = false))
    },

    editModal(id,name,desc,cfu){
      this.edit_param_id = id
      this.edit_param_name = name
      this.edit_param_desc = desc
      this.cfuSelectedEdit = cfu
      this.$bvModal.show('edit-param')
    },
    editParam() {
      this.form.isLoading = true

      this.$http
        .post('/division-config/update', {
          id: this.edit_param_id,
          name: this.edit_param_name,
          desc: this.edit_param_desc,
          cfu: this.cfuSelectedEdit
        })
        .then(() => {
          this.$notif(
            'Success',
            'Param successfully edited.',
            'success'
          )
          this.$bvModal.hide('edit-param')
          this.edit_param_id = ''
          this.edit_param_name = ''
          this.fetchDivision()
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => (this.form.isLoading = false))
    },

    showMsgBoxDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteDivision(id)
              .then(() => {
                this.$notif(
                  'Success',
                  'Division has been successfully deleted.',
                  'success'
                )
                this.fetchDivision()
              })
              .catch(err => {
                this.$notif('Error', `${err.message}`, 'error')
              })
          }
        })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>